import { render, staticRenderFns } from "./ModulPerformanceConcepts.vue?vue&type=template&id=0a991bd1&"
import script from "./ModulPerformanceConcepts.vue?vue&type=script&lang=js&"
export * from "./ModulPerformanceConcepts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports